<mulo-expandable
    [ratio]="8"
    [expandLabel]="'research.portal.fulldisplay.details.showTheRest' | translate"
    [collapseLabel]="'research.portal.fulldisplay.details.collapse' | translate"
    (expandedChange)="handleDetailsExpandChange($event)"
    [descriptionLabel]="'research.portal.fulldisplay.section.details' | translate"
>
    <mulo-dictionary
        [alignLabels]="media.is('gt-xs') ? 'right' : 'left'"
        [display]="media.is('gt-xs') ? 'rows' : 'column'"
    >
        @for (field of parsedDetails; track field.code) {
            <div
                mulo-dictionary-item
                [label]="'esploro.research.conf.research.portal.label.prefix.' + field.code | translate"
            >
                <mulo-expandable
                    [ratio]="8"
                    slot="content"
                    [expandLabel]="getExpandTranslation(field.code, true)"
                    [collapseLabel]="getExpandTranslation(field.code, false)"
                    [buttonDisabled]="!detailsExpanded"
                >
                    @if (field.hasMultipleAffiliations) {
                        <dl>
                            @for (line of field.lines; track $index) {
                                <dt class="creator-name">{{ line.text }}</dt>
                                @for (affName of line.affiliations; track $index) {
                                    <dd class="affiliation">{{ affName }}</dd>
                                }
                            }
                        </dl>
                    } @else {
                        @for (line of field.lines; track $index) {
                            <div class="line-element">
                                @if (line.url) {
                                    <a [href]="line.url" target="_blank">{{ line.text }}</a>
                                } @else {
                                    <span [innerHTML]="line.text"></span>
                                }
                            </div>
                        }
                    }
                </mulo-expandable>
            </div>
        }
    </mulo-dictionary>
</mulo-expandable>
